import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { TextField } from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'

import StatusMessage from '../..//util/StatusMessage'

class AdminQuestionnaireHome extends Component {

  constructor(props) {
    super(props);
    this.state ={
      errorMsg: '',
      data:{
        selectedQuestionniare: 'Sample Quiz',
        page: 1,
        totalPages: 'NA',
        limit: 30,
        questionnaire: [],
        questionnaireTypes: [],
        questionnaireSearchName: ''
      }
    }

  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    let url = `admin/questionnaire/types`
    let url1 = `admin/listof/questionnaires/${data.selectedQuestionniare}/${data.page}/${data.limit}`
    return api.getResponse(this.props.user.accessToken, url)
      .then((result) => {
        if(result.status === 'success') {
          data.questionnaireTypes = result.data
        }
      return api.getResponse(this.props.user.accessToken, url1)
      }).then((result) => {
        const { status, errors} = result
        if (status === 'success') {
          data.questionnaire = result.data
          data.totalPages = result.total_pages
        }
        else{
          this.setState({ errorMsg: 'Error in Fetching Details'})
        }
      this.setState({data: data})
    }).catch((err) => {
      this.setState({ errorMsg: 'Exception in Fetching Details'})
    })
  }

  fetchQuestionniareDetails = (e) => {
    
    let data = Object.assign({}, this.state.data)
    let type;
    let url;
    if(!data.questionnaireSearchName){
      if(this.state.data.selectedQuestionniare === undefined || this.state.data.selectedQuestionniare === ''){
        this.setState({errorMsg: 'Please select a Quetionnaire from dropdown before proceeding'})
      }
      else if(this.state.data.selectedQuestionniare === 'Survey') {
      type = 'Survey'
      }
      else if (this.state.data.selectedQuestionniare === 'Sample Quiz'){
      type = 'Sample Quiz'
      }  
      url = `admin/listof/questionnaires/${type}/${this.state.data.page}/${this.state.data.limit}`
      api.getResponse(this.props.user.accessToken, url).then((result) => {
          const { status, errors} = result
          if (status === 'success') {
            data.questionnaire = result.data
            data.totalPages = result.total_pages
            this.setState({data:data})
          }
          else{
            this.setState({ errorMsg: 'Error in Fetching Details'})
          }
        })
        .catch((err) => {
         this.setState({ errorMsg: 'Exception in Fetching Details'})
      })
    }

    else {
      this.fetchSearchDetails()
    }
  }

 
 handleQuestionnaireView = (e, questionnaire_id) => {
    e.preventDefault();
    let quesiton_id = questionnaire_id
    this.props.history.push(`/portal/app/admin/questionnaire/detail/${quesiton_id}`)

  }

  handleSelectedQuestionnaireType = (e) => {
    e.preventDefault();
    let data = Object.assign({}, this.state.data)
    let type = e.target.value
    data.selectedQuestionniare = e.target.value
    data.page = 1
    this.setState({data: data})
  }

  onPageTextChange = (e) => {
    let data = Object.assign({}, this.state.data);
    data.page = e.target.value;
    this.setState({data:data});   
  }

  fetchSearchDetails = (e) => {
    let data = Object.assign({}, this.state.data)
    if (!data.questionnaireSearchName){
      this.setState({errorMsg: 'Please provide a value in search field.'})
      return
    }

    let url = `admin/questionnaire/search/${data.questionnaireSearchName}/${data.selectedQuestionniare}/${data.page}/${data.limit}`
    return api.getResponse(this.props.user.accessToken, url)
    .then((result) => {
      if(result.status === 'success'){
        data.questionnaire = result.data
        data.totalPages = result.count
        this.setState({data: data, errorMsg: result.message})
      }
      else{
        data.questionnaire = []
        this.setState({errorMsg: result.message, data: data})
      }
    }).catch((err) => {
       this.setState({ errorMsg: 'Exception in Fetching Details'})
    })
  }

  onInputChange = (e) =>{
    let data = Object.assign({}, this.state.data)
    data[e.target.name] = e.target.value
    this.setState({data: data})
  }

  handleClear = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    data.questionnaireSearchName = ''
    data.page = 1
    data.questionnaire = []
    this.setState({data: data, errorMsg: ''})
  }


  render() {

    let sampleQuizComponent 
    let sampleQuizSurveyComponent
    let handleQuestionnaireView = this.handleQuestionnaireView
    let questionnaireTypeComponent

    questionnaireTypeComponent = (
    <GridCell span ="7">
     <Select 
        name ="Questionnaire"
        onChange={this.handleSelectedQuestionnaireType}
        value={this.state.data.selectedQuestionniare}
      >
        {this.state.data.questionnaireTypes.map(quest => (
          <option key={quest.id} value={quest.name}>
            {quest.name}
          </option>
        ))}
      </Select>
      <Button onClick={this.fetchQuestionniareDetails}>Fetch</Button>
    </GridCell>
    )

    if(this.state.data.questionnaire.length > 0){
      sampleQuizSurveyComponent = (
        <table className="admin-table">
        <th> Id </th>
        <th> Name </th>
        <th> Status </th>
        <th> Custom Id </th>
        <th> Created On </th>
        <th> Action </th>
        <th> Questionniare Link </th>
        <th> Subject </th>
        <th> Grade </th>
        <th> Questionniare Type </th>

        <tbody>
        {this.state.data.questionnaire.map(function(quest) {
          let activeState
          quest.active ? activeState='Active' : activeState='In Active'
          return(<tr>
              <td> {quest.id} </td>
              <td> {quest.name} </td>
              <td> {activeState}  </td>
              <td> {quest.custom_id} </td>
              <td> {quest.created_at} </td>
              <td> <Button onClick={((e) => handleQuestionnaireView(e, quest.id))}>Update</Button> </td>
              <td> {quest.questionnaire_link} </td>
              <td> {quest.subject} </td>
              <td> {quest.grade} </td>
              <td> {quest.questionnaire_type} </td>
            </tr>)

        })}

        </tbody>
        </table>
      )
    }

    return(
      <div>
        <Grid>
          <GridCell span="12">
            <Card style={{padding: '25px'}}>
              <GridCell span="12">
                <Typography use="headline6">Sample Quiz and Survey List</Typography>
              </GridCell>
            </Card>
            <br/>
          </GridCell>

          <GridCell span="12">
            <Card style={{padding: '25px'}}>
              <GridCell span="12">
                <Link to="/portal/app/admin/questionnaire/detail/0"> Add Questionniare </Link>
              </GridCell>
            </Card>
          </GridCell>
   
          {questionnaireTypeComponent}

            <GridCell span = "5">
              <TextField  className='text_input' label="Questionniare Name" autoComplete="off" name="questionnaireSearchName" onChange={this.onInputChange} value={this.state.data.questionnaireSearchName}/>
              <Button onClick={this.fetchSearchDetails}>Search</Button>
              <Button onClick={this.handleClear}>Clear</Button>
            </GridCell>

            <GridCell span = "6">
                Total Pages - {this.state.data.totalPages}
                <br/>
              <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onPageTextChange} value={this.state.data.page}/>
              <Button onClick={((e) => this.fetchQuestionniareDetails(e))}>Fetch</Button>
            </GridCell>   

            <GridCell span="12">
              {sampleQuizSurveyComponent}
            </GridCell>

          <GridCell span="10"> 
            <StatusMessage error_msg = {this.state.errorMsg}/> 
          </GridCell>
        </Grid>
      </div>
      );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminQuestionnaireHome);


// WEBPACK FOOTER //
// ./src/views/admin/AdminQuestionnaireHome.jsx